export const version = '__buildVersion';
